// Import Jquery do node_modules
import * as $ from 'jquery';
// variaveis globais.
window.jQuery = window.$ = $;
